<template>
  <div class="TextAreaInput relative">
<textarea
    v-model="value"
    class="textarea input resize-y h-auto"
    :autocomplete="autocomplete"
    :disabled="disabled"
    :class="{
    'cursor-not-allowed': disabled,
    'hasLabel': showLabel,
    'veeValidateFail border-border-errorStrong outline outline-criticalDark' : showError
  }"
    :rows="rows"
    :placeholder="focused ? placeholder : ''"
    @focus="focused = true"
    @blur="focused = false"
    />
    <div
        class="absolute left-12 pointer-events-none select-none transition-all"
        :class="[
            isFloated ? 'top-10 type-xs' : 'top-16 type-sm',
            showErrorCombined ? 'text-criticalDark' : 'text-darker'
            ]"
    >
      {{ showLabel }}
    </div>

    <div v-if="showError && errors.length" class="pointer-events-none select-none mt-8 h-16 relative">
      <div
        v-for="(error, ei) in errors"
        :key="ei"
        class="flex flex-row items-center gap-4 whitespace-nowrap"
      >
        <img
          src="/icons/exclamation-circle-critical.svg"
          class="w-16 h-16"
          alt=""
        >
        <div class="type-xs-medium leading-single text-criticalDark">{{ error }}</div>
      </div>
    </div>

    <div v-else-if="showSuccess" class="absolute top-12 right-0 pointer-events-none select-none">
      <img
        src="/icons/form-ok.svg"
        class="w-24 h-24"
        alt=""
      >
    </div>
  </div>
</template>

<script setup lang="ts">
import { useUiStore } from '~/store/ui';
const uiStore = useUiStore();

const value = defineModel<string>();

const props = withDefaults(defineProps<{
  label?: string;
  placeholder?: string;
  showError?: boolean;
  showSuccess?: boolean;
  errors?: string[];
  autocomplete?: string;
  serverName?: string;
  disabled?: boolean;
  rows?: number;
}>(), {
  label: '',
  placeholder: '',
  showError: false,
  showSuccess: false,
  errors: () => [],
  autocomplete: '',
  serverName: '',
  disabled: false,
  rows: 4,
});

const focused = ref(false);

const showErrorCombined = computed(()=> {
  return props.showError || (uiStore.formErrorMsg?.errors && uiStore.formErrorMsg?.errors[props.serverName]);
});

const showLabel = computed(()=> {
  let output = props.label;

  // Server error
  if (uiStore.formErrorMsg?.errors && uiStore.formErrorMsg?.errors[props.serverName]) {
    output += ` - ${uiStore.formErrorMsg.errors[props.serverName][0]}`;
  }
  /*else if (props.showError && props.errors.length) {
    output += ` - ${props.errors[0]}`;
  }*/
  return output;
});

const hasValue = computed(() => String(value?.value ?? '').trim().length > 0)
const isFloated = computed(() => focused.value || hasValue.value)

</script>

<style scoped lang="postcss">
.textarea {
  min-height: unset;
}
</style>
